//
// LOGIN ROUTES
//
export const BASENAME = `${process.env.PUBLIC_URL}`;

export const LOGIN_URL = `${BASENAME}/login`;
export const CODE_REFERRAL_URL = `${BASENAME}/code/:referral`;
export const LOGIN_ERROR_URL = `${BASENAME}/error/:message`;
export const ERROR_404_NOT_FOUND = `${BASENAME}/error/404-not-found`;

//
// GLOBAL ROUTES
//
export const INDEX_URL = `${BASENAME}/`;
export const CHALLENGES_URL = `${BASENAME}/challenges/`;
export const BLOG_URL = `${BASENAME}/blog-posts`;
export const FAQS_URL = `${BASENAME}/faqs`;
export const CHALLENGES_PAST_URL = `${BASENAME}/challenges/#past`;
export const CHALLENGES_ONGOING_URL = `${BASENAME}/challenges/#ongoing`;
export const CHALLENGES_DETAILS_URL = `${BASENAME}/challenges/details/:id`;
export const CHALLENGES_DETAILS_SCORES_URL = `${BASENAME}/challenges/details/:id/:score`;
export const SETTINGS_URL = `${BASENAME}/settings`;
export const MY_CHALLENGES_URL = `${SETTINGS_URL}/#my-challenges`;
export const MY_TEAM_URL = `${SETTINGS_URL}/#my-team`;
export const MY_PROFILE_URL = `${SETTINGS_URL}/#my-profile`;

//
// ADMINISTRATION ROUTES
//

// Challenges
export const ADMIN_CHALLENGES = `${BASENAME}/admin/challenges`;
export const ADMIN_CHALLENGES_DETAIL = `${BASENAME}/admin/challenges/details/:id`;
export const ADMIN_CHALLENGES_DETAIL_EDIT = `${BASENAME}/admin/challenges/details/:id/edit`;
export const ADMIN_CHALLENGES_NEW = `${BASENAME}/admin/challenges/new`;

// Donations / Rewards
export const ADMIN_DONATIONS_AND_REWARDS = `${BASENAME}/admin/donations-and-rewards`;
export const ADMIN_DONATIONS_AND_REWARDS_DETAIL = `${BASENAME}/admin/donations-and-rewards/:id`;
export const ADMIN_DONATIONS_AND_REWARDS_NEW = `${BASENAME}/admin/donations-and-rewards/:id`;

// Players
export const ADMIN_PLAYERS = `${BASENAME}/admin/players`;
export const ADMIN_PLAYERS_DETAIL = `${BASENAME}/admin/players/:id`;

// Profile
export const ADMIN_PROFILE = `${BASENAME}/admin/profile`;



// WEBPACK FOOTER //
// ./src/data/constants/router-constants.jsx